import { Utils } from "@/plugins/utils";
import router from '@/router';
import Enums from "@/plugins/Enums"

export default {
	namespaced: true,
	state: {
		lstCvn: [],
		lstGenericProducts: [],
		lstSelectedGenericProducts: [],
		cvn: null,
		cv3: { },
		insert: false,
		update: false,
		loading: false,
		loadingGenericItems: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getUpdate(state){
			return state.update
		},
		getCvn(state){
			let cvn = JSON.parse(JSON.stringify(state.cvn))
			cvn.cvnbaseicm = !cvn.cvnbaseicm ? 0 : cvn.cvnbaseicm
			cvn.cvnaliqicm = !cvn.cvnaliqicm ? 0 : cvn.cvnaliqicm
			cvn.cvnbaseise = !cvn.cvnbaseise ? 0 : cvn.cvnbaseise
			cvn.cvnbaseout = !cvn.cvnbaseout ? 0 : cvn.cvnbaseout
			cvn.cvnbasesub = !cvn.cvnbasesub ? 0 : cvn.cvnbasesub
			cvn.cvnaliqsub = !cvn.cvnaliqsub ? 0 : cvn.cvnaliqsub
			cvn.cvnbaseipi = !cvn.cvnbaseipi ? 0 : cvn.cvnbaseipi
			cvn.cvnaliqipi = !cvn.cvnaliqipi ? 0 : cvn.cvnaliqipi
			cvn.cvnbasepis = !cvn.cvnbasepis ? 0 : cvn.cvnbasepis
			cvn.cvnbasecof = !cvn.cvnbasecof ? 0 : cvn.cvnbasecof
			cvn.cvnaliqpis = !cvn.cvnaliqpis ? 0 : cvn.cvnaliqpis
			cvn.cvnaliqcof = !cvn.cvnaliqcof ? 0 : cvn.cvnaliqcof
			cvn.cvnpdif = !cvn.cvnpdif ? 0 : cvn.cvnpdif
			cvn.cvnpfcp = !cvn.cvnpfcp ? 0 : cvn.cvnpfcp
			return cvn
		},
		getCvnopercom(state){
			return state.cvn.cvnopercom
		},
		getCvnproduto(state){
			return state.cvn.cvnproduto
		},
		getCvninsumo(state){
			return state.cvn.cvninsumo
		},
		getSearch(state){
			return state.search
		},
		getItemsPerPage(state){
			return state.itemsPerPage
		},
		getLstSelectedGenericProducts(state){
			return state.lstSelectedGenericProducts
		},
		getInsert(state){
			return state.insert
		},

	},
	mutations: {
		set(state, cvn){
			state.cvn = cvn

			if (cvn && !state.insert)
				state.update = true
		},
		setCv3(state, cv3){
			state.cv3 = cv3
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cvn = null
			state.cv3 = { }
		},
		setParamsDataTable(state, payload){
			state.lstCvn = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading){
			state.loading = loading
		},
		setLstCvn(state, lstCvn){
			state.lstCvn = lstCvn
		},
		setCvn(state, cvn){
			state.cvn = cvn
		},
		setHasNext(state, hasNext){
			state.hasNext = hasNext
		},
		setSearch(state, search){
			state.search = search
		},
		setLstGenericProducts(state, lstGenericProducts){
			state.lstGenericProducts = lstGenericProducts
		},
		setLoadingGenericItems(state, loadingGenericItems){
			state.loadingGenericItems = loadingGenericItems
		},
		setLstSelectedGenericProducts(state, lstSelectedGenericProducts){
			state.lstSelectedGenericProducts = lstSelectedGenericProducts
		},
	},
	actions: {
		initForm({ commit }){
			commit("initForm")
		},
		async find({ commit, dispatch }, { cvnopercom, cvnproduto, cvninsumo }){
			commit("setLoading", true)
			commit("initForm")

			let queryParams = `cvnopercom=${cvnopercom}`
			queryParams += `&cvnproduto=${cvnproduto ?? ""}`
			queryParams += `&cvninsumo=${cvninsumo ?? ""}`

			await this._vm.$axios.get(`/Products/SpecificTaxes/Find?${queryParams}`)
			.then(response => {
				let cvn = Utils.ValidateAxiosResponse(response.data);
				commit("set", cvn)
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			commit("setLoading", false)
		},
		save({ getters, dispatch }){
			if (getters.getUpdate){
				dispatch("update")
				return
			}
			dispatch("insert")
		},
		async insert({ commit, getters, dispatch }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Products/SpecificTaxes/Insert", getters.getCvn )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tributacoes-especificas")
				commit("setCvn", null)
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update({ commit, getters, dispatch }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/Products/SpecificTaxes/Update", getters.getCvn )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tributacoes-especificas")
				commit("setCvn", null)
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete({ getters, dispatch }){
			let queryParams = `cvnopercom=${getters.getCvnopercom}`
			queryParams += `&cvnproduto=${getters.getCvnproduto ?? ""}`
			queryParams += `&cvninsumo=${getters.getCvninsumo ?? ""}`

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Products/SpecificTaxes/Delete?${queryParams}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tributacoes-especificas")
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList({ commit, getters, dispatch }, cvnproduto){
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios.get(`/Products/SpecificTaxes/FindList/${cvnproduto}`)
			.then(response => {
				let lstCvn = Utils.ValidateAxiosResponse(response.data);
				commit("setLstCvn", lstCvn)
				commit("setHasNext", lstCvn.length > getters.getItemsPerPage)
			}).catch(error => {
				commit("setLstCvn", [])
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1}){
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios.get(`/Products/SpecificTaxes/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				commit("setLstCvn", [])
				commit("setSearch", "")
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			commit("setLoading", false)
			return payload
		},
		async findGenericProducts({ commit, dispatch }, cvnopercom) {
			commit("setLoadingGenericItems", true)
			await this._vm.$axios.get(`/Products/SpecificTaxes/FindGenericProducts/${cvnopercom}`)
			.then(response => {
				let lstGenericProducts = Utils.ValidateAxiosResponse(response.data);
				commit("setLstGenericProducts", lstGenericProducts)
				commit("setLstSelectedGenericProducts", [])
			}).catch(error => {
				commit("setLstGenericProducts", [])
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			commit("setLoadingGenericItems", false)
		},
		async repeatSpecificTax({ commit, getters, dispatch }){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Copiando tributações", indeterminate: true }, {root: true})
			const body = {
				codeLst: getters.getLstSelectedGenericProducts.map(product => product.code),
				cvnopercom: getters.getCvnopercom,
				cvnproduto: getters.getCvnproduto,
				cvninsumo: getters.getCvninsumo,
			}
			await this._vm.$axios.post("/Products/SpecificTaxes/RepeatSpecificTaxe", body)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/tributacoes-especificas")
				commit("setCvn", null)
				return true
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findBusinessOperation({ commit, getters, dispatch }, cv3opercom) {
			if (!cv3opercom)
				return
				
			await this._vm.$axios.get(`/Oryx/BusinessOperation/Find/${cv3opercom}`)
			.then(response => {
				const cv3 = Utils.ValidateAxiosResponse(response.data)
				
				if (!cv3) {
					commit("setCv3", { })
					return
				}

				commit("setCv3", cv3)

				if (getters.getInsert) {
					const cvn = {
						...getters.getCvn,
						cvncfop: cv3.cv3cfop,
						cvncst: cv3.cv3cst,
						cvnbaseicm: cv3.cv3baseicm,
						cvnaliqicm: cv3.cv3aliqicm,
						cvnbaseise: cv3.cv3baseise,
						cvnbaseout: cv3.cv3baseout,
						cvnbasesub: cv3.cv3basesub,
						cvnaliqsub: cv3.cv3aliqsub,
						cvnaliqipi: cv3.cv3aliqipi,
						cvncstipi: cv3.cv3cstipi,
						cvnorigem: cv3.cv3origem,
						cvncontac: cv3.cv3contac,
						cvncontad: cv3.cv3contad,
						cvncstpis: cv3.cv3cstpis,
						cvncstcof: cv3.cv3cstcof, 
						cvnbasepis: cv3.cv3basepis,
						cvnbasecof: cv3.cv3basecof,
						cvnaliqpis: cv3.cv3aliqpis,
						cvnaliqcof: cv3.cv3aliqcof,
						cvncbenef: cv3.cv3cbenef,
						cvnpdif: cv3.cv3pdif,
						cvnpfcp: cv3.cv3pfcp,
						cvnaliibsu: cv3.cv3aliibsu,
						cvndifibsu: cv3.cv3difibsu,
						cvnaliibsm: cv3.cv3aliibsm,
						cvndifibsm: cv3.cv3difibsm,
						cvnalicbs: cv3.cv3alicbs,
						cvndifcbs: cv3.cv3difcbs,
						cvncstiva: cv3.cv3cstiva,
						cvntribiva: cv3.cv3tribiva,
					}

					if (cv3.cv3itemfab == Enums.SalesItemType.MATERIALS)
						cvn.cvnproduto = ""
					if (cv3.cv3itemfab == Enums.SalesItemType.PRODUCTS || cv3.cv3itemfab == Enums.SalesItemType.IN_MANUFACTURING)
						cvn.cvninsumo = ""

					commit("set", cvn)
				}
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
		}
	}
}